
// states
import { isFilteringActive } from '../../ui/ui-states.mjs'
import { getObjectSession } from '../../session/object-session.mjs'


export const setListSessionStates = async (listId) => {
  const listSession = await getObjectSession(listId)
  isFilteringActive.value = listSession?.data?.isFilteringActive || false
}